import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ICmsComponent, ICmsContent, NICmsContentComponent, NICmsContentField } from '@icms/core/content';
import { ColorOptions } from '@df/ui/atomic/atomic-options';
import { UiComponent } from '@df/ui/ui.component';
export namespace NCmsNewsletter {
    export interface IComponentData extends NICmsContentComponent.IData {
        title: string;
        subtitle?: string;
        bottomCopy?: string;
        source?: string;
        successMessage: string;
        textColor?: string;
        successMessageColor?: string;
        buttonCopy?: string;
    }
}
@ICmsComponent<CmsNewsletterComponent>({
    id: 'newsletter',
    name: 'Newsletter',
    tags: ['newsletter'],
    fields: [
        {
            key: 'title',
            type: NICmsContentField.EFieldType.text,
            title: 'Title',
            required: true,
            default: 'Sign up to our Newsletter'
        },
        {
            key: 'subtitle',
            type: NICmsContentField.EFieldType.textarea,
            title: 'Subtitle',
            default:
                'Horem ipsum dolor sit amet, consectetur adipiscing elit. Nunc vulputate libero et velit interdum, ac aliquet odio mattis.'
        },
        {
            key: 'bottomCopy',
            type: NICmsContentField.EFieldType.textarea,
            title: 'Bottom copy',
            default:
                'Your privacy is important to us, please see our <a href="/privacy-policy">privacy policy</a>. You can unsubscribe at any time.'
        },
        <NICmsContentField.IChoiceField>{
            key: 'textColor',
            type: NICmsContentField.EFieldType.choice,
            previewMode: 'color',
            title: 'Text color',
            options: ColorOptions,
            default: 'col-w'
        },
        {
            key: 'buttonCopy',
            type: NICmsContentField.EFieldType.text,
            title: 'Button copy',
            default: 'Sign up'
        },
        <NICmsContentField.IChoiceField>{
            key: 'successMessageColor',
            type: NICmsContentField.EFieldType.choice,
            previewMode: 'color',
            title: 'Success message color',
            options: ColorOptions,
            default: 'col-3'
        },
        {
            key: 'successMessage',
            type: NICmsContentField.EFieldType.text,
            title: 'Success message',
            default: `Thank you, you'll be hearing from us soon.`,
            required: true
        },
        {
            key: 'source',
            type: NICmsContentField.EFieldType.text,
            title: 'Source id for tracking',
            default: 'cms-component'
        }
    ]
})
@Component({
    selector: 'cms-newsletter',
    templateUrl: './cms-newsletter.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CmsNewsletterComponent extends UiComponent implements NICmsContentComponent.IComponent {
    @ICmsContent({
        type: 'component'
    })
    component!: NCmsNewsletter.IComponentData;
}
